import BillingsPlanEntryRelatedTaxiTaxiResponse, {
  BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel,
  BillingsPlanEntryRelatedTaxiTaxiResponseData,
  BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus,
  BillingsPlanEntryRelatedTaxiTaxiResponseDataOrderForwardingAction,
} from "../../../../../api/raily/billings/plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";
import BillingsPlanEntryRelatedTaxiTaxi, {
  BillingsPlanEntryRelatedTaxiTaxiItem,
  BillingsPlanEntryRelatedTaxiTaxiItemContractDetails,
} from "./billings-plan-entry-related-taxi-taxi";

const createDataItemStatus = (
  status: BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus,
): BillingStatus => {
  switch (status) {
    case BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
    case BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus.REOPENED:
      return BillingStatus.REOPENED;
  }
};

const createDataItemBillingModel = (
  billingModel: BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel.SABS:
      return BillingModel.SABS;
    case BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel.OTHER:
      return BillingModel.OTHER;
  }
};

const createDataItemContractDetails = (
  orderForwardingAction: BillingsPlanEntryRelatedTaxiTaxiResponseDataOrderForwardingAction,
): BillingsPlanEntryRelatedTaxiTaxiItemContractDetails => {
  return {
    companyName: orderForwardingAction.contract.consumerTaxi.displayName,
    distanceRate: orderForwardingAction.contract.distanceRate,
    model: createDataItemBillingModel(orderForwardingAction.contract.model),
  };
};

const createDataItem = (
  data: BillingsPlanEntryRelatedTaxiTaxiResponseData,
): BillingsPlanEntryRelatedTaxiTaxiItem => {
  return {
    billingUuid: data.id,
    forwardingUuid: data.orderForwardingAction.id,
    contractDetails: createDataItemContractDetails(data.orderForwardingAction),
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    distance: data.distance,
    amountForDistance: data.amountForDistance,
    internalOrderId:
      data.orderForwardingAction.transportingOrder.cargoOrder.humanId,
    allContributionsAmount: data.allContributionsAmount,
    isDraft: data.draft,
    date: data.date,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
    status: createDataItemStatus(data.status),
    readOnly: data.readOnly,
  };
};

const createData = (
  responseData: BillingsPlanEntryRelatedTaxiTaxiResponseData[],
): BillingsPlanEntryRelatedTaxiTaxiItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: BillingsPlanEntryRelatedTaxiTaxiResponse,
): BillingsPlanEntryRelatedTaxiTaxi => {
  return {
    data: createData(response.data),
  };
};

const billingsPlanEntryRelatedTaxiTaxiFactory = {
  create,
};

export default billingsPlanEntryRelatedTaxiTaxiFactory;
